import React from 'react';
import { MailIcon, MessageCircleIcon, SparklesIcon } from 'lucide-react';
import { EMAIL_ADDRESS, EMAIL_URL } from '../lib/constants';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
export function FinalCtaSection() {
  return <section className="w-full bg-brand-500 py-20 text-white sm:py-28" data-id="element-32" data-mp="3qrgcjfmd0uhc">
      <div className="mx-auto max-w-4xl px-5 text-center sm:px-8" data-id="element-33" data-mp="3vs43y2ei3dc3">
        <Reveal data-id="element-34" data-mp="2y5dqs2efs8yd">
          <span className="inline-flex items-center gap-2 bg-lime px-3 py-2 text-[0.7rem] font-extrabold uppercase tracking-[0.12em] text-ink" data-id="element-35" data-mp="2y5x393lbi550">
            <SparklesIcon className="h-4 w-4" data-id="element-36" data-mp="331m1n3llpfzq" />
            Este puede ser tu siguiente paso
          </span>
        </Reveal>
        <Reveal delay={0.05} data-id="element-37" data-mp="3cu9ytzghtlyz">
          <h2 className="mt-6 font-display text-5xl font-extrabold leading-[0.9] sm:text-7xl" data-id="element-38" data-mp="3cujr5tp0g57u">
            Hagamos que tu negocio se vea como se merece.
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-39" data-mp="2kcntv2xddjmh">
          <p className="mx-auto mt-6 max-w-2xl text-base font-semibold leading-relaxed text-brand-100 sm:text-lg" data-id="element-40" data-mp="2kbw6ughu8u7t">
            Cuéntame qué haces. Yo me encargo de convertirlo en una web que se siente tuya.
          </p>
        </Reveal>
        <Reveal delay={0.15} data-id="element-41" data-mp="23m71puzjp1y9">
          <div className="mt-9 flex flex-col items-center gap-4 sm:flex-row sm:justify-center" data-id="element-42" data-mp="23lf8urxc1ibo">
            <CtaButton variant="light" icon={<MessageCircleIcon className="h-5 w-5" data-id="element-44" data-mp="1ymkmjg05pbmt" />} data-id="element-43" data-mp="1ynvrvk992rg1">Escríbeme por WhatsApp</CtaButton>
            <a href={EMAIL_URL} className="inline-flex items-center gap-2 text-sm font-extrabold text-white underline decoration-lime decoration-2 underline-offset-4 transition-colors hover:text-lime focus:outline-none focus-visible:ring-4 focus-visible:ring-lime" data-id="element-45" data-mp="1umabhoxibv13">
              <MailIcon className="h-4 w-4" data-id="element-46" data-mp="1fpt0iyt8cif2" />
              {EMAIL_ADDRESS}
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.2} data-id="element-47" data-mp="3eyzrx1cotic7">
          <p className="mt-5 text-sm font-semibold text-brand-100" data-id="element-48" data-mp="3a1r86wbw568u">Una conversación honesta. Sin compromiso. Sin vueltas.</p>
        </Reveal>
      </div>
    </section>;
}